import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { environment } from '../environments/environment';

/**
 * Componente principal de la aplicación que estructura el header, footer y sección de trabajo
 */
@Component({
  selector: 'prv-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  /**
   * Provides access to information about a route associated with a component that is loaded in an outlet.
   */
  private readonly router: Router;
  /**
   * Activo footer
   */
  public showHead = false;
  /**
   * Flag para controlar si reCAPTCHA ya está cargado
   */
  private recaptchaLoaded = false;

  /**
   * initial AppComponent
   * @param router rutas
   */
  public constructor(router: Router) {
    this.router = router;
    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        event.url === '/assignment-module/printTemplate/PrintSchedule' ||
        event.url === '/search-module/printTemplate/PrintSchedule'
          ? (this.showHead = false)
          : (this.showHead = true);
      }
    });
  }

  /**
   * Metodo encargado de ejecutarse al iniciar el componente
   */
  public ngOnInit(): void {
    this.loadRecaptchaScript();
  }

 /**
 * Metodo que carga el script de Google ReCaptcha Enterprise
 * Solucionado para evitar errores de CORS
 */
public async loadRecaptchaScript(): Promise<void> {
  // Verificar si ya está cargado
  if (this.recaptchaLoaded || (window as any)['grecaptcha']) {
    return;
  }

  // Verificar si el script ya existe
  const existingScript = document.querySelector('script[src*="recaptcha"]');
  if (existingScript) {
    this.recaptchaLoaded = true;
    return;
  }

  try {
    await this.createRecaptchaScript();
  } catch (error) {
    console.error('Error cargando reCAPTCHA Enterprise:', error);
  }
}

/**
 * Crea y carga el script de reCAPTCHA Enterprise
 */
private createRecaptchaScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${environment.googleCaptcha}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      this.recaptchaLoaded = true;
      resolve();
    };

    script.onerror = (error) => {
      console.error('Error loading reCAPTCHA Enterprise script:', error);
      reject(error);
    };

    // Agregar al head para mejor compatibilidad
    document.head.appendChild(script);
  });
}
  /**
   * Metodo que se ejecuta cuando de detecta que se recargara la pagina
   * @param event Información del Evento
   */
  @HostListener('window:beforeunload', ['$event'])
  public unloadHandler(event: Event) {
    event.preventDefault();
  }
}
